// extracted by mini-css-extract-plugin
export default {"content":"Question_content__gfSpV"};